import styled from 'styled-components'

export const StyledTextArea = styled.textarea`
  width: 100%;
  height: auto;
  padding: 12px 20px;
  border-radius: 4px;
  border: 1px solid var(--text-light);

  &::placeholder {
    color: var(--bs-gray-500);
  }
`
